import React from 'react';

import ViewProject from './ViewLeave';

interface ViewProjectIndexProps {
  leaveId: any;
  setMethod: () => void;
}

const ViewProjectIndex: React.FC<ViewProjectIndexProps> = ({
  leaveId,
  setMethod,
}) => {
  return <ViewProject leaveId={leaveId} setMethod={setMethod} />;
};

export default ViewProjectIndex;
